var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tux-mdes-verification-options',{attrs:{"show-cancel-button":true,"issuer-name":_vm.issuerName,"options":_vm.options,"selected-credential-reference":_vm.selectedCredential},on:{"submit":_vm.onContinue,"cancel":_vm.onCancel}})}
var staticRenderFns = []

export { render, staticRenderFns }